export default {
  top: '26',
  right: '20',
  bottom: '20',
  left: '20',
  containLabel: true
};